import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';

import redPolygon from '../assets/images/svg/red-polygon.svg';
import greenPolygon from '../assets/images/svg/green-polygon.svg';

import Decisions from 'routes/decision-trees/components/Decisions';

const NsoJ = ({ setCurrentPage }) => {
  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('nsoI'), []);

  const yesHandler = () => setCurrentPage('nsoK');
  const noHandler = () => setCurrentPage('nsoL');

  const firstCaseContent = (
    <>
      <h4>
        Less <br /> than
      </h4>
      <h3>1 year</h3>
    </>
  );

  const secondCaseContent = (
    <>
      <h4>
        More <br /> than
      </h4>
      <h3>1 year</h3>
    </>
  );

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <h1 className='page-heading text-center mb-5'>
        After you&apos;ve exercised your options, how long do you intend to hold your stocks?
      </h1>

      <Decisions
        directionColumn
        firstCaseContent={firstCaseContent}
        secondCaseContent={secondCaseContent}
        firstCaseBackground={redPolygon}
        secondCaseBackground={greenPolygon}
        firstCaseHandler={yesHandler}
        secondCaseHandler={noHandler}
      />
    </div>
  );
};

NsoJ.propTypes = {
  setCurrentPage: PropTypes.func
};

export default NsoJ;
